import { useCallback } from 'react';

export const useFormattedDate = () => {
  const locale = 'en-US';

  const mghDateFormater = useCallback(
    (value, type = 'date', autoDate = true, isUtc = false) => {
      let dateValue = value;

      // Handle UTC and string input
      if (isUtc && typeof dateValue === 'string') {
        dateValue = `${dateValue}Z`;
      }

      if (typeof dateValue === 'string') {
        const parsed = new Date(dateValue);
        if (!isNaN(parsed)) dateValue = parsed;
      }

      // Handle valid Date instance
      if (dateValue instanceof Date && !isNaN(dateValue)) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const datetimeOptions = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true };

        if (type === 'date') {
          return dateValue.toLocaleDateString(locale, options).replaceAll('/', '-');
        } else if (type === 'datetime') {
          return dateValue.toLocaleString(locale, datetimeOptions).replaceAll('/', '-');
        } else if (type === 'time') {
          return dateValue.toLocaleTimeString(locale, {
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
          });
        }
      } else if (dateValue === undefined && autoDate !== false) {
        // Default to current date
        const now = new Date();
        return now.toLocaleDateString(locale, {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      }

      return '';
    },
    [locale]
  );

  return { mghDateFormater };
};
